module.exports = __webpack_public_path__ + "static/media/transparent.2e88653c.png";